import { Clock, Calendar } from 'lucide-react';

interface ResearchCardProps {
  title: string;
  description: string;
  readTime: string;
  updated: string;
  icon: string;
  onClick: () => void;
}

export default function ResearchCard({
  title,
  description,
  readTime,
  updated,
  icon,
  onClick
}: ResearchCardProps) {
  return (
    <div
      onClick={onClick}
      className="bg-white rounded-2xl border border-neutral-200 p-6 hover:border-blue-500 hover:shadow-lg transition-all cursor-pointer group"
    >
      {/* Icon */}
      <div className="text-4xl mb-4 group-hover:scale-110 transition-transform">
        {icon}
      </div>

      {/* Title */}
      <h3 className="text-xl font-semibold text-neutral-900 mb-2 group-hover:text-blue-600 transition-colors">
        {title}
      </h3>

      {/* Description */}
      <p className="text-neutral-600 text-sm mb-4 line-clamp-3">
        {description}
      </p>

      {/* Metadata */}
      <div className="flex items-center gap-4 text-xs text-neutral-500">
        <div className="flex items-center gap-1">
          <Clock className="w-3 h-3" />
          <span>{readTime}</span>
        </div>
        <div className="flex items-center gap-1">
          <Calendar className="w-3 h-3" />
          <span>{updated}</span>
        </div>
      </div>
    </div>
  );
}
